import { render, staticRenderFns } from "./banks.vue?vue&type=template&id=06b18ac1&scoped=true&"
import script from "./banks.vue?vue&type=script&lang=ts&"
export * from "./banks.vue?vue&type=script&lang=ts&"
import style1 from "./banks.vue?vue&type=style&index=1&id=06b18ac1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b18ac1",
  null
  
)

export default component.exports